import Modal from "bootstrap/js/dist/modal";

export function initLockScreen() {
	const lockedScreen = document.getElementById('lockedScreen');

	if (lockedScreen) {
		const lockedScreenModal = new Modal(lockedScreen, {
			backdrop: 'static',
			keyboard: false
		});

		lockedScreenModal.show();

		lockedScreen.addEventListener('DOMNodeRemoved', e => {
			location.reload();
		});
	}
}

initLockScreen();
